const applications =
{
    helmet :
    {
        title : 'Applications' ,
        metas : []
    }
};

export default applications ;